import React from "react";
import { FaGift } from "react-icons/fa";

import {
  formatDateFR,
  formatEuro,
  getReferralMeta,
  getStatusMeta,
} from "../utils/subscriptionDashboardUtils";

export default function ReferralDiscountsTable({ referrals, loading }) {
  if (loading || !referrals.length) return null;

  const referralMeta = getReferralMeta();

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-violet-500 via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-4 flex flex-col gap-2 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Parrainage
            </p>

            <h2 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
              <FaGift className="text-violet-600 dark:text-violet-300" />
              Réductions de parrainage
            </h2>

            <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              Les montants négatifs correspondent aux réductions appliquées à
              votre abonnement.
            </p>
          </div>

          <span className="rounded-full bg-violet-50 px-3 py-1 text-xs font-bold text-violet-700 dark:bg-violet-500/10 dark:text-violet-300">
            {referrals.length} réduction(s)
          </span>
        </div>

        <div className="overflow-x-auto rounded-[22px] border border-slate-200 dark:border-slate-800">
          <table className="w-full min-w-[820px]">
            <thead className="bg-slate-50 text-xs uppercase tracking-[0.14em] text-slate-500 dark:bg-slate-950/70 dark:text-slate-400">
              <tr>
                <th className="px-4 py-3 text-left font-bold">Type</th>
                <th className="px-4 py-3 text-right font-bold">Montant</th>
                <th className="px-4 py-3 text-left font-bold">Période</th>
                <th className="px-4 py-3 text-left font-bold">Statut</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100 text-sm dark:divide-slate-800">
              {referrals.map((referral) => {
                const status = getStatusMeta(referral.status);

                return (
                  <tr key={referral.id} className={`transition ${status.row}`}>
                    <td className="px-4 py-4 align-top">
                      <div className="flex flex-col gap-1">
                        <span
                          className={`inline-flex w-max rounded-full px-2.5 py-1 text-xs font-bold ring-1 ${referralMeta.badge}`}
                        >
                          {referralMeta.label}
                        </span>

                        {referral.product ? (
                          <p className="text-sm font-medium text-slate-700 dark:text-slate-200">
                            {referral.product}
                          </p>
                        ) : null}
                      </div>
                    </td>

                    <td className="px-4 py-4 text-right align-top">
                      <p className="text-lg font-black text-violet-700 dark:text-violet-300">
                        {formatEuro(referral.total_amount)}
                      </p>
                    </td>

                    <td className="px-4 py-4 align-top text-slate-700 dark:text-slate-200">
                      {formatDateFR(referral.start_date)}
                      <span className="mx-2 text-slate-400">→</span>
                      {formatDateFR(referral.end_date)}
                    </td>

                    <td className="px-4 py-4 align-top">
                      <span
                        className={`inline-flex rounded-full px-2.5 py-1 text-xs font-bold ring-1 ${status.badge}`}
                      >
                        {status.label}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}